import { Injectable } from '@angular/core';
import { NgModel } from '@angular/forms';

@Injectable()
export class FormValidationService {
  public errors = {
    required:          'This field is required.',
    numDependents:     'Please enter a number between 0 and 13.',
    dependentAge:      'Please enter a valid age (0 to 24).',
    email:             'Please enter a valid email address.',
    yearsInSchool:     'Please enter a valid number (0 to 50).',
    phone:             'Please enter a valid phone number using the format (000)999-8888',
    phoneWithExt:      'Please enter a valid phone number using the format (000)999-8888 Ext. 000',
    ssn:               'Please enter a valid Social Security number using the format 000-00-0000.',
    date:              'Please enter a valid date.',
    currency:          'Please enter a number using only decimals and digits.',
    zipCode:           'Please enter a valid 5 or 9-digit zip code.',
    positiveCurrency:  'Please enter a positive number using only decimals and digits.',
    yearBuilt:         'Please enter a valid year.',
    yearsOwnedRented:  'Please enter a valid number (0 to 99).',
    houseNumber:       'Please enter a valid number.',
    yearsInProfession: 'Please enter a valid number between 0 and 50 (decimals allowed).'
  };

  // Please don't remove the '$^|^null$|^undefined$|' at the start of each regex.
  // If a field is required, please add the 'required' attribute
  public regex = {
    numDependents:     '^$|^null$|^undefined$|^[0-9]$|^1[0-3]$', // 0 to 13
    dependentAge:      '^$|^null$|^undefined$|^[0-9]$|^1[0-9]$|^2[0-4]', // 0 to 24 years: "You can claim dependent children
                                                                        // until they turn 19,
                                                                        // unless they go to college, in which case they
                                                                        // can be claimed until they turn 24"
    email:             '^$|^null$|^undefined$|^.+@.+', // Don't make this too crazy,
                                                       // the backend needs to do the more robust validation
                                                       // TODO: Error for @loandepot.com emails.
    yearsInSchool:     '^$|^null$|^undefined$|^[0-9]$|^[1-4][0-9]$|^50$', // less than or equal to 50 years
    phone:             '^$|^null$|^undefined$|^\\(\\d{3}\\)\\d{3}-\\d{4}$', // empty string or (111)123-4567
    phoneWithExt:      '^$|^null$|^undefined$|^\\(\\d{3}\\)\\d{3}-\\d{4} Ext\\. ?(\\d{0,5})$', // empty string or (111)123-4567 Ext. 12345
    ssn:               '^$|^null$|^undefined$|\\d{3}-\\d{2}-\\d{4}', // 000-00-0000
    date:              '^$|^null$|^undefined$|^(19|20)\\d{2}-\\d{2}-\\d{2}$', // yyyy-mm-dd
    currency:          '^$|^null$|^undefined$|^0$|^\\-?[0-9]+(?:\\.\\d{1,2})?$', // allows negative numbers
    zipCode:           '^$|^null$|^undefined$|^\\d{5}$|^\\d{5}\-\\d{4}$', // 5 or 9-digit (requires hyphen)
    positiveCurrency:  '^$|^null$|^undefined$|^0$|^[0-9]+(?:\\.\\d{1,2})?$',
    yearsOwnedRented:  '^$|^null$|^undefined$|^0$|^[1-9]$|^[1-9][0-9]$', // disallow numbers that start with 0
    numberOfUnits:     '^$|^null$|^undefined$|^\\d',
    yearBuilt:         '^$|^null$|^undefined$|^[12][0-9]{3}$', // 1000 to 2099
    yearsInProfession: '^$|^null$|^undefined$|^0.\\d{1,3}$|^[1-9](.\\d{1,3})?$|^[1-4][0-9](.\\d{1,3})?$|^50$',
  };


  public placeholder = {
    phone:         '(000)999-8888',
    phoneWithExt:  '(000)999-8888 Ext. 000',
    ssn:           '000-00-0000',
    date:          'yyyy-mm-dd', // placeholder for unsupported browsers
  };

  public maxlength = {
    numDependents:     2,
    dependentAge:      2,
    email:             255, // TODO
    yearsInSchool:     2,
    phone:             13, // backend truncates at 13
    phoneWithExt:      24, // TODO
    ssn:               11,
    date:              10,
    firstName:         255, // TODO
    lastName:          255, // TODO
    middleName:        255, // TODO
    currency:          13,  // TODO
    zipCode:           10,
    city:              255, // TODO
    county:            255, // TODO
    yearsOwnedRented:  2,
    unitNumber:        15,
    numberOfUnits:     15,
    yearBuilt:         4,
    yearsInProfession: 6, // allow for decimals like 13.255 (empower allows 3)
  };

  errorTitle(model: NgModel, type: string) {
    let message: string = '';
    if (type !== null && !model.valid) {
      message = this.errors[type];
    }

    return message;
  }
}
